import React, { useMemo } from 'react';
import { FeatureProvider, useFeaturesQuery } from '@billda/features-ui';
import { apiClient } from '../../shared/api/axiosClient';
import { useAuthStore } from '../../features/auth/stores/authStore';
import { getTokenIdentifier } from '@billda/shared-ui';

interface Props {
  children: React.ReactNode;
}

export const FeaturesProviderAdapter: React.FC<Props> = ({ children }) => {
  const { isAuthenticated, token } = useAuthStore();

  // Get token identifier to key the features query per-organisation
  const tokenIdentifier = useMemo(() => {
    return token ? getTokenIdentifier(token) : null;
  }, [token]);

  const {
    data: features,
    isLoading,
    error,
  } = useFeaturesQuery({
    apiClient,
    enabled: isAuthenticated,
    tokenIdentifier,
  });

  return (
    <FeatureProvider
      features={features ?? {}}
      isLoading={isLoading}
      error={error ?? null}
    >
      {children}
    </FeatureProvider>
  );
};
